export default __webpack_public_path__ + "static/media/grey-blue-pink-keys.b64f1d82.png";